import { STAFFING_TYPES, StaffListItem } from '@libs/models/talents/talent';

export function prepareTalentsOptions(
  talents: StaffListItem[],
  selectedQualifications?: string[],
  currentSelection?: string[],
  currentLocationID?: string,
) {
  return (
    talents
      .filter((t) => {
        if (!selectedQualifications) {
          return true;
        }

        if (currentSelection?.includes(t.id)) {
          return true;
        }

        // Show only talents with selected qualifications
        return t.qualifications.some((q) => selectedQualifications.includes(q.id));
      })
      // Internal first, then by name
      .sort((a, b) => {
        if (a.staffingType === b.staffingType) {
          return a.fullName.localeCompare(b.fullName);
        }
        if (a.staffingType === STAFFING_TYPES.INTERNAL) {
          return -1;
        } else if (b.staffingType === STAFFING_TYPES.INTERNAL) {
          return 1;
        }
        return a.staffingType.localeCompare(b.staffingType);
      })
      .map((talent) => {
        return {
          id: talent.id,
          key: talent.id,
          staffingType: talent.staffingType,
          // Group by staffing type
          groupBy: talent.staffingType,
          label: talent.fullName,
          value: talent.id,
          disabled:
            selectedQualifications?.length && !talent.qualifications.some((q) => selectedQualifications.includes(q.id)),
          qualifications: talent.qualifications,
          isOriented:
            (talent.orientedList || []).find((o) => o.locationId === currentLocationID && o.value)?.value || false,
          staffingTYpe: talent.staffingType,
          agency: talent.agency ?? null,
        };
      })
  );
}
